@if (to.beforeText) {
	<label class="sr-only" [for]="field.id">{{ to.beforeText }}</label>
	<p [ngClass]="to.beforeTextClass">{{ to.beforeText }}</p>
}
@if (type !== 'number') {
	<input
		[type]="type"
		[formControl]="formControl | fromAbstractToFormControl"
		class="form-control"
		[formlyAttributes]="field"
		[attr.aria-invalid]="showError"
		[attr.hasValue]="formControl?.value !== null && formControl?.value !== undefined"
		[ngClass]="{
			'is-invalid': showError,
			'is-disabled': to.disabled,
			'form-control--after-text': to.afterText,
			'form-control--before-text': to.beforeText
		}" />
} @else {
	<input
		type="number"
		[formControl]="formControl | fromAbstractToFormControl"
		class="form-control"
		[formlyAttributes]="field"
		[attr.aria-invalid]="showError"
		[attr.hasValue]="formControl?.value !== null && formControl?.value !== undefined"
		[ngClass]="{
			'is-invalid': showError,
			'is-disabled': to.disabled,
			'form-control--after-text': to.afterText,
			'form-control--before-text': to.beforeText
		}" />
}
@if (to.afterText) {
	<label class="sr-only" [for]="field.id">{{ to.afterText }}</label>
	<p [ngClass]="to.afterTextClass">{{ to.afterText }}</p>
}
